import React from 'react'
import { Card, CardActions, CardTitle, CardText } from 'material-ui-legacy/Card'

import DeleteButton from '../UI/DeleteButton'
import EditButton from '../UI/EditButton'
import CloseButton from '../UI/CloseButton'

const DirectorCard = props => {
  // Data can be received either as director or itemData.
  const director = props.director || props.itemData

  return (
    <Card>
      <CardTitle title={director.attributes.fullName} />
      <CardText>
        {director.attributes.title && (
          <p>
            <strong>Title:</strong> {director.attributes.title}
          </p>
        )}
        {director.attributes.email && (
          <p>
            <strong>E-mail:</strong>&nbsp;
            <a href={`mailto:${director.attributes.email}`}>
              {director.attributes.email}
            </a>
          </p>
        )}
        {director.attributes.formattedPhones && (
          <p>
            <strong>Phones:</strong> {director.attributes.formattedPhones}
          </p>
        )}
        {director.attributes.address && (
          <p>
            <strong>Address:</strong> {director.attributes.address}
          </p>
        )}
        {director.attributes.city && (
          <p>
            <strong>City:</strong> {director.attributes.city}
          </p>
        )}
        {director.attributes.province && (
          <p>
            <strong>State/Province:</strong>{' '}
            {director.attributes.province}
          </p>
        )}
        {director.attributes.postalCode && (
          <p>
            <strong>Postal code:</strong> {director.attributes.postalCode}
          </p>
        )}
        {director.attributes.country && (
          <p>
            <strong>Country:</strong> {director.attributes.country}
          </p>
        )}
      </CardText>

      <CardActions>
        {props.editCallback && <EditButton onTouchTap={props.editCallback} />}
        {props.deleteCallback && (
          <DeleteButton
            onTouchTap={props.deleteCallback}
            confirmMessage={
              <p>
                Are you sure you want to delete{' '}
                <strong>{director.attributes.name}</strong>? There's no
                undo.
              </p>
            }
          />
        )}
        {props.closeCallback && (
          <CloseButton onTouchTap={props.closeCallback} />
        )}
      </CardActions>
    </Card>
  )
}

export default DirectorCard



// WEBPACK FOOTER //
// ./src/components/Directors/DirectorCard.jsx